import {
  GET_RENTAL_HOUSES,
} from 'constants/rentalHouses';

export default (state = [], action) => {
    switch (action.type) {
    case `${GET_RENTAL_HOUSES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
